import { TouchableLogo } from "@/features/common/components/navigation/TouchableLogo";
import { useFeatureEnabled } from "@/features/common/hooks/useFeatureEnabled";
import { LanguageSwitchButton } from "@/features/landing/components/LanguageSwitchButton";
import { Search } from "@/features/search/components/Search";
import { FeatureNameEnum } from "@/generated/generated-hooks";

import { SiteTopNavigationUserCredentialView } from "./SiteTopNavigationUserCredentialView";

const DesktopHeader = () => {
  const { isEnabled } = useFeatureEnabled();
  const isSearchEnabled = isEnabled(FeatureNameEnum.Search);

  return (
    <div
      className="w-full max-w-screen-lg px-4"
      data-test-id="SiteTopNavigation-container"
    >
      <div className="grid grid-cols-12">
        <div className="col-span-3 flex flex-start items-center">
          <TouchableLogo />
        </div>

        <div className="col-span-5 md:col-span-6">
          {isSearchEnabled && <Search />}
        </div>

        <div className="col-span-4 md:col-span-3">
          <div className="w-full h-full flex justify-end items-center space-x-2 divide-x">
            <div className="w-full h-full flex justify-end items-center">
              <SiteTopNavigationUserCredentialView />
            </div>

            <LanguageSwitchButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopHeader;
